import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Settings from 'components/settings';
import RtlLayout from 'components/RtlLayout';
import ThemeColorPresets from 'components/ThemeColorPresets';
import MotionLazyContainer from 'components/animate/MotionLazyContainer';
import NotistackProvider from 'components/NotistackProvider';
import AppRouter from 'routers';

import ThemeProvider from 'theme';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ThemeColorPresets>
          <RtlLayout>
            <NotistackProvider>
              <MotionLazyContainer>
                <Settings />
                <AppRouter />
              </MotionLazyContainer>
            </NotistackProvider>
          </RtlLayout>
        </ThemeColorPresets>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
